import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedKey = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 49,
	viewBox: "0 0 48 49",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.1042 30.4375C15.7535 30.4375 17.1554 29.8602 18.3099 28.7057C19.4644 27.5512 20.0417 26.1493 20.0417 24.5C20.0417 22.8507 19.4644 21.4488 18.3099 20.2943C17.1554 19.1398 15.7535 18.5625 14.1042 18.5625C12.4549 18.5625 11.0529 19.1398 9.89843 20.2943C8.74391 21.4488 8.16666 22.8507 8.16666 24.5C8.16666 26.1493 8.74391 27.5512 9.89843 28.7057C11.0529 29.8602 12.4549 30.4375 14.1042 30.4375ZM14.1042 36.375C10.8055 36.375 8.00173 35.2205 5.6927 32.9115C3.38367 30.6024 2.22916 27.7986 2.22916 24.5C2.22916 21.2014 3.38367 18.3976 5.6927 16.0885C8.00173 13.7795 10.8055 12.625 14.1042 12.625C16.776 12.625 19.1098 13.3837 21.1055 14.901C23.1011 16.4184 24.4948 18.2986 25.2864 20.5417H41.862L45.7708 24.4505L38.8437 32.3672L33.8958 28.4583L29.9375 32.4167L25.9792 28.4583H25.2864C24.4618 30.8333 23.0269 32.7465 20.9818 34.1979C18.9366 35.6493 16.6441 36.375 14.1042 36.375Z",
		fill: "url(#paint0_linear_19636_1855)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_19636_1855",
		x1: 2.00005,
		y1: 36.6875,
		x2: 32.1838,
		y2: .718501,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedKey;
